<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'addToastAction'
    ]),
    addToast (type, content) {
      let data = {
        type: type,
        content: content
      }
      this.addToastAction(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/toastMethods.vue